export default "__VITE_ASSET__BQkKP$QN__"